<template>
    <div>
        <b-card>
            <template slot="header">
                <b-row>
                    <b-col cols="9" sm="7" md="6" lg="6" xl="5"></b-col>
                    <b-col cols="9" sm="7" md="6" lg="6" xl="5">
                        <h3>Entidad Emisora de Permisos</h3>
                    </b-col>
                </b-row>
            </template>
            <b-row>
                <b-col cols="2" sm="3" md="4" lg="4" xl="3">
                    <select v-if="!mostrarBotonEdicion" class="form-control input-placedark input-dark colorBorde" 
                        v-model="indexEntidadEmisora">
                      <option
                            v-for="(entidad, index) in infoEntidadEmisora"
                            :value="index"
                            :key="index"
                      >{{ entidad.nombre }}</option>
                    </select>
                    <b-form-input v-else
                        disabled
                        v-model="nombre">
                    </b-form-input>
                </b-col>
                <b-col cols="2" sm="3" md="4" lg="4" xl="2">
                    <b-form-input
                        disabled
                        v-model="codigo"
                        placeholder="Código"
                        type="number">
                    </b-form-input>
                </b-col>
                <b-col cols="2" sm="3" md="4" lg="4" xl="2">
                    <b-form-input
                        disabled
                        v-model="abreviatura"
                        placeholder="Abreviatura"
                        >
                    </b-form-input>
                </b-col>
                <b-col cols="2" sm="3" md="4" lg="4" xl="2">
                    <b-form-input
                        v-model="numeroPermiso"
                        placeholder="Num. Permiso"
                        type="text">
                    </b-form-input>
                </b-col>
                <b-col cols="2" sm="3" md="4" lg="4" xl="2">
                    <template v-if="!mostrarBotonEdicion">
                        <b-button 
                        :disabled="validarEntidad()"
                        variant="primary"
                        @click="AddEntidad()">
                        Agregar
                        <i class="fa fa-file" aria-hidden="true"></i>
                        <i class="fa fa-plus ml-2" aria-hidden="true"></i>
                    </b-button>
                    </template>
                    <template v-else>
                        <b-button 
                            :disabled="validarEntidadEdicion()"
                            variant="warning"
                            @click="enviarEdicionEntidad()">
                            Editar
                        </b-button>
                        <b-button 
                            v-b-tooltip.hover.right="'Cancelar Edición'"
                            variant="ligth"
                            class="ml-3"
                            @click="cancelarEdicion()">
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </b-button>
                    </template>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col cols="9" sm="7" md="6" lg="6" xl="12">
                    <template v-if="actualizarTabla">
                        <div class="text-center">
                            <h2><i class="fa fa-spin fa-spinner"></i> Cargando...</h2>
                        </div>
                    </template>
                    <template v-else>
                        <b-table
                        small
                        hover
                        responsive
                        outlined
                        :items="entidadEmisora"
                        :fields="entidadEmisora_lista">
                        <template slot="eliminarEditar" slot-scope="row">
                            <b-button 
                                size="sm"
                                variant="outline-primary"
                                @click="capturaInfoEdicionEntidad(row.item)">
                                <i class="fa fa-edit" aria-hidden="true"></i>
                            </b-button>
                            <b-button
                                size="sm"
                                variant="outline-danger"
                                @click="eliminarEntidad(row.item)">
                                <i class="fa fa-trash" aria-hidden="true"></i>
                            </b-button>
                        </template>
                        </b-table>
                        <b-row>
                            <b-col cols="9" sm="7" md="6" lg="6" xl="6">
                                <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
                            </b-col>
                            <b-col cols="9" sm="7" md="6" lg="6" xl="6">
                                <div class="float-right">
                                <b-pagination
                                    :total-rows="total"
                                    v-model="paginaActual"
                                    @input="listarEntidad"
                                    :per-page="limite"
                                ></b-pagination>
                                </div>
                            </b-col>
                        </b-row>
                    </template>
                </b-col>
            </b-row>
        </b-card>
        <vue-snotify></vue-snotify>
    </div>
</template>
<script>
import axios from 'axios'
import { entidadEmisora } from "@/shared/utils";
export default{
    name:"Negocios_EntidadEmisorsa",
    components:{

    },
    data() {
        return {
            codigo:'',
            nombre:'',
            abreviatura:'',
            numeroPermiso:'',
            indexEntidadEmisora:0,
            capturaIndexEntidad:0,
            infoEntidadEmisora:entidadEmisora,
            entidadEmisora:[],
            entidadEmisora_lista:[
               { key: "codigo", label: "Código"},
               { key: "nombre", label: "Nombre Entidad"},
               { key: "abreviatura", label: "Abreviatura"},
               { key: "numeroPermiso", label: "Num. Permiso"},
               { key: "eliminarEditar", label: "Editar-Eliminar"},
            ],
            total: 0.0,
            desde: 0.0,
            hasta: 0.0,
            paginaActual: 1,
            limite:12,
            actualizarTabla:true,
            idEntidad:'',
            mostrarBotonEdicion: false,
            capturaCodigo:'',
            entidadNueva:false,
        }
    },
    mounted(){
        this.listarEntidad();
    },
    watch:{
        indexEntidadEmisora(value){
            this.capturaIndexEntidad = value
            this.codigo = this.infoEntidadEmisora[value].codigo,
            this.abreviatura  = this.infoEntidadEmisora[value].abreviatura 
        },
    },
    methods:{
        validarEntidad(){
            if(this.indexEntidadEmisora !=0 && this.numeroPermiso !=''){
                return false
            }else{
                return true
            } 
        },
        validarEntidadEdicion(){
            if(this.numeroPermiso !=''){
                return false
            }else{
                return true
            }
        },
        AddEntidad(){
        let send = {}
            send.token = this.$store.getters.userToken,
            send.codigo = this.codigo
            send.nombre = this.infoEntidadEmisora[this.capturaIndexEntidad].nombre,
            send.abreviatura = this.abreviatura,
            send.numeroPermiso = this.numeroPermiso,
            axios.post(process.env.VUE_APP_API_URL + "entidadpermisos/crear",send)
            .then(response =>(
                this.$snotify.success(response.data.msg, "Exito"),
                this.limpiarDatos(),
                this.listarEntidad()
             ))
            .catch(error =>(
                this.$snotify.warning(error.response.data.msg, "Error")
            ))    
        },
        limpiarDatos(){
            this.codigo = '',
            this.indexEntidadEmisora = 0,
            this.abreviatura ='',
            this.numeroPermiso =''  
        },
        listarEntidad(){
             this.actualizarTabla = true;
            axios.post(process.env.VUE_APP_API_URL + "entidadpermisos/listar",{
                token:this.$store.getters.userToken,
                page: this.paginaActual,
                limit: this.limite,
                order:"desc"
            })
            .then(response =>(
                this.entidadEmisora = response.data.data,
                this.actualizarTabla = false,
                this.total = response.data.total,
                this.desde = response.data.from,
                this.hasta = response.data.to
            ))
            .catch(error=>(
                console.log('ERROR LISTA INFORMACION',error.response.data)
            ))
        },
        capturaInfoEdicionEntidad(item){
            this.idEntidad = item.idEntidad
            this.codigo = item.codigo,
            this.nombre = item.nombre,
            this.abreviatura = item.abreviatura,
            this.numeroPermiso = item.numeroPermiso
            this.mostrarBotonEdicion = true;
        },
        enviarEdicionEntidad(){
            let nuevaInfo ={}
            nuevaInfo.token = this.$store.getters.userToken,
            nuevaInfo.idEntidad = this.idEntidad,
            nuevaInfo.codigo = this.codigo,
            nuevaInfo.nombre = this.nombre, 
            nuevaInfo.abreviatura = this.abreviatura,
            nuevaInfo.numeroPermiso = this.numeroPermiso,
            axios.post(process.env.VUE_APP_API_URL + "entidadpermisos/actualizar",nuevaInfo)
            .then(response =>(
                this.$snotify.success(response.data.msg, "Exito"),
                this.mostrarBotonEdicion = false,
                this.listarEntidad(),
                this.limpiarDatos()
            ))
            .catch(error=>(
                console.log(error.response.data)
            ))
        },
        eliminarEntidad(item){
            axios.post(process.env.VUE_APP_API_URL + "entidadpermisos/borrar",{
                token: this.$store.getters.userToken,
                idEntidad: item.idEntidad
            })
            .then(response =>(
                this.$snotify.success(response.data.msg, "Exito"),
                this.listarEntidad()
            ))
            .catch(error=>(
                console.log(error.response.data)
            )) 
        },
        cancelarEdicion(){
            this.limpiarDatos(),
            this.mostrarBotonEdicion = false
        }
    }
}
</script>